export default "/memento-mori/assets/c1c465804e5923008cf62bfaeb2322a5.mp3";